import { useSeekGlobalData } from './useSeekGlobalData';

export const useSeekCurrencies = () => {
  const { processedData, setProcessedData } = useSeekGlobalData({
    key: 'currencies',
    endpoint: '/api/v4/seek/currencies'
  });

  return { currencies: processedData, setCurrencies: setProcessedData };
};
